var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{style:({ color: _vm.iconColor }),attrs:{"icon":"exclamation-circle","size":"lg","title":_vm.tooltip}})}
var staticRenderFns = []

export { render, staticRenderFns }